/*
 * Gilded 003 "free coffee with machine" auto-add.
 *
 * Loaded globally from layout/theme.liquid (not just the machine PDP) so the
 * gift line is reconciled on every page — removing the machine from the minicart
 * anywhere drops the $0 gift, closing the orphaned-free-item loophole. Keeps the
 * cart in sync with a single rule: while the machine is in the cart there is
 * always exactly one $0 gift bag (Gilded 003 Lonya Grande); with no machine there
 * is none. It reconciles the cart after every cart mutation, so it covers the
 * standard Add-to-cart form, the Memorial / Buy-Now bundle CTA, upsells and
 * minicart quantity/remove changes without patching each handler individually.
 *
 * Config is provided on window.__machineGift by the snippet:
 *   { giftVariantId: <number>, machineProductId: <number> }
 *
 * The gift is added as a separate $0 line, so it never touches the machine's
 * price, selling plan or any stacked discount code.
 */
(function () {
  var cfg = window.__machineGift || {};
  var GIFT_ID = String(cfg.giftVariantId || "");
  var MACHINE_ID = String(cfg.machineProductId || "");

  // Bail if we weren't handed the two ids we need.
  if (!GIFT_ID || !MACHINE_ID) return;

  // Use the native fetch for our own reads/writes so they never re-trigger the
  // reconcile hook installed below (which would recurse).
  var origFetch = window.fetch.bind(window);

  var busy = false; // a reconcile pass (including its own writes) is running
  var again = false; // a mutation arrived mid-pass; run one more pass after

  function getJSON(url, opts) {
    return origFetch(url, opts).then(function (r) {
      return r.json();
    });
  }

  function write(url, body) {
    return getJSON(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function () {
      return true;
    });
  }

  // Re-render the minicart / cart totals using the theme's own helpers.
  function refreshUI() {
    try {
      if (typeof cCart === "undefined") return;
      if (typeof cCart.updateCartContent === "function") cCart.updateCartContent();
      if (typeof cCart.updateCartStats === "function") cCart.updateCartStats();
    } catch (e) {}
  }

  function reconcile() {
    if (busy) {
      again = true;
      return;
    }
    busy = true;

    getJSON("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var hasMachine = false;
        var gift = null;

        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (String(it.product_id) === MACHINE_ID) hasMachine = true;
          if (String(it.variant_id) === GIFT_ID) gift = it;
        }

        // Machine present, gift missing -> add exactly one.
        if (hasMachine && !gift) {
          return write("/cart/add.js", {
            items: [{ id: Number(GIFT_ID), quantity: 1 }],
          });
        }
        // Machine present, gift qty drifted -> pin to one.
        if (hasMachine && gift && gift.quantity !== 1) {
          return write("/cart/change.js", { id: gift.key, quantity: 1 });
        }
        // No machine but a gift lingers (removed machine / standalone) -> drop it.
        if (!hasMachine && gift) {
          return write("/cart/change.js", { id: gift.key, quantity: 0 });
        }
        // Already consistent.
        return null;
      })
      .then(function (changed) {
        busy = false;
        if (changed) refreshUI();
        if (again) {
          again = false;
          reconcile();
        }
      })
      .catch(function (e) {
        busy = false;
        console.error("[machine-gift] reconcile failed:", e);
        if (again) {
          again = false;
          reconcile();
        }
      });
  }

  // React to any cart mutation triggered elsewhere on the page. Our own writes
  // go through origFetch above, so they are never seen here.
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = origFetch(input, init);
    if (CART_MUTATION.test(url)) {
      p.then(function () {
        reconcile();
      }).catch(function () {});
    }
    return p;
  };

  // Initial pass: covers returning carts, orphaned gifts and qty drift.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", reconcile);
  } else {
    reconcile();
  }
})();
